import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-148">
      <div className="max-w-3xl mx-auto text-center" data-id="element-149">
        <ShieldCheckIcon className="h-16 w-16 mx-auto mb-6" style={{
        color: '#f59e0b'
      }} aria-hidden="true" data-id="element-150" />

        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-8" style={{
        color: '#f1f5f9'
      }} data-id="element-151">
          30 DÍAS COMPLETAMENTE LIBRES DE RIESGO
        </h2>

        <div className="text-lg leading-relaxed mb-8 space-y-4" style={{
        color: '#94a3b8'
      }} data-id="element-152">
          <p data-id="element-153">Descarga la guía. Sigue los pasos. Construye tu primera página.</p>
          <p data-id="element-154">
            Si en 30 días — por cualquier razón — sientes que esto no es para
            ti:
          </p>
          <p className="text-2xl font-bold" style={{
          color: '#f59e0b'
        }} data-id="element-155">
            Te devolvemos cada peso de tus $49.999.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-8 text-base" style={{
        color: '#f1f5f9'
      }} data-id="element-156">
          <span data-id="element-157">✅ Sin preguntas</span>
          <span data-id="element-158">✅ Sin formularios</span>
          <span data-id="element-159">✅ Sin esperas</span>
          <span data-id="element-160">✅ Sin discusiones</span>
        </div>

        <p className="text-lg mb-10" style={{
        color: '#94a3b8'
      }} data-id="element-161">
          Un mensaje. Un reembolso. Así de simple.
        </p>

        <div className="rounded-md p-6 border mb-12 inline-block" style={{
        backgroundColor: '#1e293b',
        borderColor: '#334155'
      }} data-id="element-162">
          <p className="text-base mb-1" style={{
          color: '#94a3b8'
        }} data-id="element-163">
            Tu riesgo total:{' '}
            <strong style={{
            color: '#f1f5f9'
          }} data-id="element-164">
              $49.999
            </strong>
          </p>
          <p className="text-base" style={{
          color: '#94a3b8'
        }} data-id="element-165">
            Tu potencial:{' '}
            <strong style={{
            color: '#f59e0b'
          }} data-id="element-166">
              6 millones al mes
            </strong>
          </p>
        </div>

        <p className="text-xs mb-12 block" style={{
        color: '#64748b'
      }} data-id="element-167">
          ⚠️ Los resultados varían según el esfuerzo y la constancia. Los
          usuarios que siguen el plan reportan entre $500.000 y $2.500.000 en
          sus primeros 60 días.
        </p>

        <CTAButton text="EMPEZAR CON GARANTÍA TOTAL — SOLO $49.999" subtitle="✅ Riesgo máximo $49.999 · ✅ Potencial 6 millones/mes · ✅ Descarga inmediata" scrollTo="ebook-main" data-id="element-168" />
      </div>
    </section>;
}